import store from '@Store';
import { cancelRelativeContextRequest } from './RelativeContextService';
import { fetchRelativeContexts, clearRelativeContext } from './RelativeContextActions';

const relativeContextService = {
  async getRelativeContexts(params, history) {
    const { context, hitSetKey, resultName, databaseId, searchId } = params;
    const requiredParams = {
      context,
      hitSetKey,
      resultName,
      databaseId,
      searchId,
    };

    try {
      const result = await store.dispatch(fetchRelativeContexts(requiredParams, history));

      return result && result.toJS();
    } catch (e) {
      return Logger.reject(e);
    }
  },

  clearSavedContexts() {
    store.dispatch(clearRelativeContext());
  },

  cancelRelativeContextRequest,
};

export default relativeContextService;
